import { UIStyleConstants } from "../Common/UIStyleConstants";

export class MappingConstants {
    static MAPPING_RULES_DROPPABLE_ID: string = "xmappingrules";
    static MAPPING_SOURCE_DROPPABLE_ID: string = "xmappingsource";

    static MAPPING_LINE_COLOR: string = UIStyleConstants.GRAY_LIGHTER_COLOR;

    static HIGHLIGHT_MAPPING_LINE_COLOR: string = UIStyleConstants.BLUE_COLOR;

    static MAPPING_PREFIX_SOURCE_ITEM = "source_";
    static MAPPING_PREFIX_DESTINATION_ITEM = "destination_";
    static MAPPING_PREFIX_RULE_ITEM = "rule_";

    static DRAGGING_CONNECTOR_SUFFIX = "__drag_connector";

    static getDestinationConnectorIdForMappingRule(targetPath: string): string {
        return `${this.MAPPING_PREFIX_DESTINATION_ITEM}${targetPath}_connector_formappingrule`;
    }

    static getMappingRuleConnectorIdForDestination(targetPath: string): string {
        return `${this.MAPPING_PREFIX_RULE_ITEM}${targetPath}_connector_fordestination`;
    }

    static getMappingRuleConnectorIdForSource(targetPath: string): string {
        return `${this.MAPPING_PREFIX_RULE_ITEM}${targetPath}_connector_forsource`;
    }
}
